import { Button, TextField } from "@material-ui/core";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../components/modal/Modal";
import Table from "../../components/table/Table";
import {
  addNewStorageBox,
  addStorageBox,
  fetchAllstorageBox,
} from "../../redux/features/storageBox.features";
import ProductStoreDetails_Preview from "../Product/ProductStoreDetails_Preview";

const CreateStorageBox = () => {
  const [values, setValues] = useState({});
  const [preview, showPreview] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllstorageBox());
  }, [dispatch]);

  let storageBoxState = useSelector((state) => {
    return state.storageBoxReducer;
  });

  let { storageBox } = storageBoxState;
  const [canShow, setShow] = useState(false)
  const [selectedStorageBox, setSelectedStorageBox] = useState({})

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const saveBox = () => {
    dispatch(
      addStorageBox({
        storageBoxName: values.storageBoxName,
        storageBoxRowSize: values.storageBoxRowSize,
        storageBoxColumnSize: values.storageBoxColumnSize,
        // storageBoxSlots: values.storageBoxSlots
      })
    );

    alert("New Storage Box Created Successfully");
    setValues({});
  };

  const storageBoxTableHead = [
    "storageBoxName",
    "storageBoxRowSize",
    "storageBoxColumnSize",
    "status",
  ];

  const renderHead = (item, index) => <th key={index}>{item}</th>;
  const renderBody = (item, index) => {
    // let selectedCustomerStore =  props.selectedCustomer
    return (
      <tr onClick={() => {
        setSelectedStorageBox(item)
        setShow((state) => !state)}} key={index}>
        {/* <td>{item.bankId}</td> */}
        <td>{item.storageBoxName}</td>
        <td>{item.storageBoxRowSize}</td>
        <td>{item.storageBoxColumnSize}</td>

        <td>{item.status}</td>
      </tr>
    );
  };

  return (
    <div className="flex w-full flex-col">
      <div className="flex text-2xl font-extrabold">Create Storage Box</div>
      <div className="flex">
        <TextField
          name="storageBoxName"
          onChange={handleChange}
          placeholder="Tray name is A"
        ></TextField>
        <TextField
          onChange={handleChange}
          name="storageBoxRowSize"
          placeholder="5 rows"
        ></TextField>
        <TextField
          name="storageBoxColumnSize"
          onChange={handleChange}
          placeholder="10 column"
          type={"number"}
        ></TextField>
        <TextField
          name="storageBoxSlots"
          value={
            Number(values.storageBoxColumnSize) *
            Number(values.storageBoxRowSize)
          }
          placeholder=""
          type={"number"}
        ></TextField>
      </div>
      <div className="flex my-4">
        <Button
          variant="contained"
          onClick={() => {
            saveBox();
          }}
          color="success"
        >
          Create Storage Box
        </Button>
        <Button variant="contained" color="error">
          Cancel
        </Button>
      </div>

      
      <Table
        tableHeaderStyle={{
          style: {
            backgroundColor: "var(--main-bg)",
            color: "white",
            fontWeight: "900",
          },
        }}
        limit="5"
        headData={storageBoxTableHead}
        renderHead={(item, index) => renderHead(item, index)}
        bodyData={storageBox}
        renderBody={(item, index) => renderBody(item, index)}
      />

<Modal
        modal_title={"View Product"}
        canShow={canShow}
        updateModalState={() => setShow((state) => !state)}
      >
        <Box>
          <ProductStoreDetails_Preview storageBox={selectedStorageBox} />
        </Box>
      </Modal>


    </div>
  );
};

export default CreateStorageBox;
